import React from "react";
import clsx from "clsx";

type TooltipPosition = "top" | "bottom" | "left" | "right";

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  show?: boolean;
  position?: TooltipPosition;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  text,
  children,
  show = true,
  position = "top",
  className,
}) => {
  const positionClasses = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-3",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-3",
    left: "right-full top-1/2 -translate-y-1/2 mr-3",
    right: "left-full top-1/2 -translate-y-1/2 ml-3",
  };

  const arrowClasses = {
    top: "top-full left-1/2 -translate-x-1/2 border-t-[#1A1F3C]",
    bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-[#1A1F3C]",
    left: "left-full top-1/2 -translate-y-1/2 border-l-[#1A1F3C]",
    right: "right-full top-1/2 -translate-y-1/2 border-r-[#1A1F3C]",
  };

  return (
    <div className={clsx("relative group inline-block", className)}>
      {show && (
        <div
          className={clsx(
            "absolute bg-[#1A1F3C] text-white px-4 py-2 text-sm rounded-lg opacity-0 transition-opacity duration-300 pointer-events-none group-hover:opacity-100 font-['Proxima_Nova'] whitespace-nowrap z-10 shadow-md",
            positionClasses[position]
          )}
        >
          {text}
          <div
            className={clsx(
              "absolute border-4 border-transparent",
              arrowClasses[position]
            )}
          ></div>
        </div>
      )}
      {children}
    </div>
  );
};

export default Tooltip;